<template>
  <div 
    class="opple-ota-progress"
  >
    <p :style="{ color: infoColor }">
      {{ otaInfo }}
    </p>
    <div
      v-if="isShowProgress"
      class="ota_progress"
      style="margin-left: 0;"
    >
      <el-progress
        :percentage="progress"
        :color="customColor"
      />
    </div>
  </div>
</template>
<script>
import { OTA_STATUS_ENUMS } from './enums';

export default {
  components: { 
  },
  props: {
    otaStatus: {
      type: Number,
      default: OTA_STATUS_ENUMS.PADDING
    },
    progress: {
      type: Number,
      default: 0
    },
    otaInfo: {
      type: String,
      default: ''
    },
    customColor: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
    }
  },
  
  computed: {
    isShowProgress() {
      return [
        // OTA_STATUS_ENUMS.CANCEL_FAILED, 
        OTA_STATUS_ENUMS.PROCESSING
      ].includes(this.otaStatus);
    },
    infoColor() {
      return this.hasError ? 'red' : '';
    }
  },


  created() {
   
  },

  methods: {
    cancleOta() {

    }
  }
}
</script>

<style lang="scss">
.opple-ota-progress {
  width: 180px;
}
</style>